module.exports = __webpack_public_path__ + "img/sintaclunsValor.39e07422.png";